import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageRenderer from "@/components/PageRenderer";
import { Button } from "@/components/ui/button";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined); // undefined=loading, null=not found

  useEffect(() => {
    setPage(undefined);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(null));
  }, [slug]);

  if (page === undefined) return <div className="py-24 text-center text-muted-foreground" data-testid="page-loading">Loading…</div>;
  if (page === null)
    return (
      <div className="py-24 text-center" data-testid="page-not-found">
        <h1 className="font-serif text-3xl font-bold">Page not found</h1>
        <p className="text-muted-foreground mt-2">The page you’re looking for doesn’t exist.</p>
        <Link to="/"><Button className="mt-6 rounded-full bg-primary text-primary-foreground">Back home</Button></Link>
      </div>
    );
  return <PageRenderer page={page} />;
}
